import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import './styles.scss';

// Redux
import { useDispatch } from "react-redux";
import { fetchCompanyPurchaseHistory } from "../../../../../Redux/Slices/companyManagementSlice";

// Custom Components
import PurchaseCard from 'Components/UserManagement/ViewUser/PurchaseHistory';

function PurchaseHistoryCompanyManagement() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [purchaseData, setPurchaseData] = useState([]); // State to store fetched purchase data
    const [loading, setLoading] = useState(false); // Loading indicator
    const [hasMoreData, setHasMoreData] = useState(true); // Flag to check if there's more data to load
    const [page, setPage] = useState(1); // Track the current page
    const itemsPerPage = 10; // Number of items to fetch per page

    const containerRef = useRef(null); // Ref to the container for scroll event

    // Fetch initial data
    useEffect(() => {
        loadMoreData(); // Trigger load on mount
    }, []);

    // Load more data when triggered by scroll
    const loadMoreData = async () => {
        if (loading || !hasMoreData) return; // Prevent unnecessary loading if already fetching or no more data

        setLoading(true); // Start loading
        const data = await fetchPageData(page); // Fetch data for the current page

        if (data.length > 0) {
            setPurchaseData((prevData) => [...prevData, ...data]); // Append new data to the existing list
            setPage(prevPage => prevPage + 1); // Increment page for next fetch
        } else {
            setHasMoreData(false); // No more data available
        }

        setLoading(false); // End loading
    };

    // Helper function to fetch data for a specific page
    const fetchPageData = async (page) => {
        return new Promise((resolve) => {
            dispatch(
                fetchCompanyPurchaseHistory({
                    data: {
                        id,
                        page,
                        limit: itemsPerPage
                    },
                    callBack: (response) => {
                        // Get data_list array from the response or an empty array if undefined
                        resolve(response.data?.data_list || []);
                    }
                })
            );
        });
    };

    // Check if the user has scrolled to the bottom
    const handleScroll = () => {
        const container = containerRef.current;
        if (container) {
            const scrollHeight = container.scrollHeight;
            const scrollTop = container.scrollTop;
            const clientHeight = container.clientHeight;

            if (scrollHeight - scrollTop <= clientHeight && hasMoreData && !loading) {
                loadMoreData(); // Load more data when scrolled to the bottom
            }
        }
    };

    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            container.addEventListener("scroll", handleScroll); // Attach scroll event listener
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", handleScroll); // Clean up scroll event listener on unmount
            }
        };
    }, [loading, hasMoreData]); // Ensure the event listener is set up when loading or hasMoreData changes

    return (
        <div className="purchaseHistoryCompaniesContainer">
            <div className="purchaseHistoryCompaniesHeader">
                <h2>Purchase History</h2>
            </div>
    
            <div 
                className="purchaseHistoryCardsContainer"
                ref={containerRef} // Attach ref to the container
                style={{ overflowY: 'auto', maxHeight: '80vh' }} // Ensure the container is scrollable
            >
                {purchaseData.length === 0 && !loading && !hasMoreData && (
                    <p style={{ textAlign: 'center', color: 'gray', fontSize:'4vh' }}>No data found.</p>
                )}
    
                {purchaseData.map((purchaseHistory, index) => (
                    <PurchaseCard 
                        backgroundColor="#FFFFFF"
                        key={index}
                        title={purchaseHistory?.purchase_request}
                        kit_code={purchaseHistory.product_name}
                        pr_code={`${purchaseHistory?.purchase_request_id || "-"}`}
                        purchase_quantity={purchaseHistory?.quantity || "-"}
                        notes={purchaseHistory?.message || "-"}
                    />
                ))}
            </div>
    
            {loading && <p>Loading more data...</p>}
        </div>
    );
    
}

export default PurchaseHistoryCompanyManagement;
